import {Input, Modal, Row, Col} from 'antd';
import {useState} from "react";

const {TextArea} = Input;

export const DescriptionWidget = ({description, onChange, props, children}) => {
    const [isOpen, setOpen] = useState(false);
    const [nextDescription, setNextDescription] = useState(description);

    const onOpen = () => {
        setNextDescription(description);
        setOpen(true);
    }

    const onOk = () => {
        setOpen(false)
        if (onChange) {
            onChange(nextDescription)
        }
    }

    const onCancel = () => {
        setOpen(false);
    }

    const onInputChange = (e) => {
        setNextDescription(e.target.value);
    }

    return <div>
        <div style={{cursor: 'pointer', color: "#108ee9"}} onClick={onOpen}>{children}</div>
        <Modal width={600} open={isOpen} onOk={onOk} onCancel={onCancel}>
            <Row style={{paddingTop: '5px', paddingBottom: '5px'}}>
                <Col><TextArea style={{width: 512}} placeholder={`Inventory Description`} onChange={onInputChange} value={nextDescription} rows={4} maxLength={512} showCount /></Col>
            </Row>
        </Modal>
    </div>
}